import { Link } from "react-router-dom";

const entries = [
  {
    path: "/brand",
    eyebrow: "BRAND",
    title: "品牌介绍",
    desc: "品牌历史、文化与使命，了解白峰美羽十六年的坚持。",
    icon: "ri-award-line",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20elegant%20brand%20archive%20scene%20with%20neutral%20fabric%20swatches%20and%20a%20ceramic%20vessel%20on%20soft%20beige%20surface%2C%20warm%20natural%20light%2C%20refined%20editorial%20photography%2C%20calm%20composition&width=800&height=600&seq=home-category-brand&orientation=landscape",
  },
  {
    path: "/news",
    eyebrow: "NEWS",
    title: "最新动态",
    desc: "活动公告、媒体报道与品牌动态，掌握第一手资讯。",
    icon: "ri-newspaper-line",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20modern%20brand%20event%20space%20with%20soft%20beige%20backdrop%20and%20warm%20lighting%2C%20quiet%20premium%20atmosphere%2C%20editorial%20photography%2C%20calm%20neutral%20palette&width=800&height=600&seq=home-category-news&orientation=landscape",
  },
  {
    path: "/products",
    eyebrow: "PRODUCTS",
    title: "产品资讯",
    desc: "经典、星选与限定系列，感受可触摸的质感与工艺。",
    icon: "ri-shopping-bag-3-line",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20product%20still%20life%20with%20neatly%20folded%20neutral%20fabric%20items%20on%20a%20clean%20light%20surface%2C%20soft%20studio%20lighting%2C%20warm%20neutral%20tones%2C%20elegant%20refined%20composition&width=800&height=600&seq=home-category-products&orientation=landscape",
  },
];

export default function CategoryEntries() {
  return (
    <section className="max-w-site mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {entries.map((entry) => (
          <Link
            key={entry.path}
            to={entry.path}
            className="group relative rounded-lg overflow-hidden h-64 md:h-72 cursor-pointer"
          >
            <img
              src={entry.image}
              alt={entry.title}
              title={`${entry.title} - 白峰美羽`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/40 to-primary-950/10"></div>
            <div className="relative h-full flex flex-col justify-end p-6">
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-background-50/15 backdrop-blur text-background-50 mb-4">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <p className="text-[11px] tracking-[0.3em] text-accent-300 mb-2">{entry.eyebrow}</p>
              <h3 className="text-xl font-heading font-semibold text-background-50">{entry.title}</h3>
              <p className="mt-2 text-sm text-background-200 leading-relaxed">{entry.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-accent-300">
                进入栏目
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}